module.exports = __webpack_public_path__ + "media/creditOverview.250f9dad.svg";